module.exports = __webpack_public_path__ + "static/media/sample_header_bg.0b761a39.png";